import { Injectable } from '@angular/core';
import { StarbaseDataService } from 'starbase-launcher';
import { CallNumberModel } from '../models/callNumberModel';
import { WebApiService } from 'starbase-login';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CallNoService extends StarbaseDataService<CallNumberModel> {
  protected _staleDataTimeout = 30000;
  protected _getOneUri = '/api/CallNumberModels/';
  protected _getAllUri = '/api/CallNumberModels';
  protected _postUri = '/api/CallNumberModels';
  protected _putUri = '/api/CallNumberModels/';
  protected _deleteUri = '/api/CallNumberModels/';
  protected _broadSearchUri = '/api/CallNumberModels/GetCallNoBroadSearch';

  constructor(private _http: HttpClient, private _webApiSvc: WebApiService) {
    super(_http, _webApiSvc);
  }
}
